export interface GenericStateModel {
  variant: AppVariants;
}

export enum AppVariants {
  DOE = 'DOE',
  OCW = 'OCW'
}
